import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import IntegrationReport from './IntegrationReport';
import { FaArrowLeft, FaGavel } from "react-icons/fa";
import AOS from "aos";
import "aos/dist/aos.css";
import "./Version.css"; // Reusing the high-end layout

function Terms() {
  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  return (
    <div className="version-page">
      <nav className="navbar">
        <div className="logo-container">
          <Link to="/" className="back-link">
            <FaArrowLeft /> Home
          </Link>
          <h2 className="logo" style={{marginLeft: '20px'}}>🇮🇳 Bharat Connect</h2>
        </div>
      </nav>

      <div className="version-container">
        <div style={{textAlign: 'center', marginBottom: '40px'}}>
          <FaGavel style={{fontSize: '3rem', color: '#138808', marginBottom: '20px'}} />
          <h1 data-aos="fade-down">Terms of Service</h1>
          <div className="version-tag" style={{display: 'inline-block', marginBottom: '10px', background: '#e3f2fd', color: '#1976d2'}}>v1.0.1 Official</div>
          <p className="version-subtitle" data-aos="fade-down" data-aos-delay="100">
            Last Updated: March 24, 2026
          </p>
        </div>

        <div className="timeline">
          <div className="timeline-item" data-aos="fade-up">
            <div className="timeline-dot"></div>
            <div className="timeline-content">
              <h3>1. Compliance with Indian Law</h3>
              <p>Bharat Connect operates under the jurisdiction of the Information Technology Act, 2000 (and its subsequent amendments). By using this service, you agree to comply with all applicable local, state, and national laws of India.</p>
            </div>
          </div>

          <div className="timeline-item" data-aos="fade-up">
            <div className="timeline-dot"></div>
            <div className="timeline-content">
              <h3>2. Acceptable Use Policy</h3>
              <p>You may not use Bharat Connect for any of the following:</p>
              <ul>
                <li>Disseminating content that is harmful, obscene, or racially offensive.</li>
                <li>Impersonating any person or entity.</li>
                <li>Engaging in automated "bot" activities or scraping without explicit permission.</li>
                <li>Transmitting malicious code or viruses.</li>
              </ul>
            </div>
          </div>

          <div className="timeline-item" data-aos="fade-up">
            <div className="timeline-dot"></div>
            <div className="timeline-content">
              <h3>3. Service Availability (SLA)</h3>
              <p>While we strive for 100% uptime, Bharat Connect is provided "as is". We are not liable for any service interruptions caused by upstream infrastructure providers (e.g., Google Cloud/Firebase) or local ISP connectivity issues within India.</p>
            </div>
          </div>

          <div className="timeline-item" data-aos="fade-up">
            <div className="timeline-dot"></div>
            <div className="timeline-content">
              <h3>5. Governing Law</h3>
              <p>These terms are governed by the laws of India. Any disputes arising from the use of Bharat Connect shall be subject to the exclusive jurisdiction of the courts in New Delhi.</p>
            </div>
          </div>

          <div className="timeline-item" data-aos="fade-up">
            <div className="timeline-dot"></div>
            <div className="timeline-content">
              <h3>6. Limitation of Liability</h3>
              <p>Bharat Connect shall not be held liable for any indirect, incidental, or consequential damages resulting from the use or inability to use the service.</p>
            </div>
          </div>
        </div>
      </div>
      <IntegrationReport />
    </div>
  );
}

export default Terms;
